import { t } from "ttag";

import { SettingsPageWrapper } from "metabase/admin/components/SettingsSection";
import { UpsellPerformanceTools } from "metabase/admin/upsells";
import { usePageTitle } from "metabase/hooks/use-page-title";

export const ToolsUpsell = () => {
  usePageTitle(t`Erroring questions`, { titleIndex: 1 });

  return (
    <SettingsPageWrapper title={t`Erroring questions`}>
      <UpsellPerformanceTools source="settings-tools" />
    </SettingsPageWrapper>
  );
};
